/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateLocationRequest,
  FullLocationUi,
  LocationInListDTO,
  LocationOptionDTO,
  LocationTableRequest,
  LocationTableResponse,
  UpdateLocationRequest,
} from '../models';

export interface CreateLocationOperationRequest {
    createLocationRequest: CreateLocationRequest;
}

export interface DeleteByPublicLocationIdRequest {
    publicId: string;
}

export interface GetLocationByIdRequest {
    publicId: string;
}

export interface GetLocationsTableRequest {
    locationTableRequest: LocationTableRequest;
}

export interface UpdateLocationOperationRequest {
    updateLocationRequest: UpdateLocationRequest;
}

/**
 * 
 */
export class LocationApiControllerApi extends runtime.BaseAPI {

    /**
     */
    async createLocationRaw(requestParameters: CreateLocationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LocationInListDTO>> {
        if (requestParameters['createLocationRequest'] == null) {
            throw new runtime.RequiredError(
                'createLocationRequest',
                'Required parameter "createLocationRequest" was null or undefined when calling createLocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/location`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createLocationRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createLocation(requestParameters: CreateLocationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LocationInListDTO> {
        const response = await this.createLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteByPublicLocationIdRaw(requestParameters: DeleteByPublicLocationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling deleteByPublicLocationId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/location/{publicId}`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteByPublicLocationId(requestParameters: DeleteByPublicLocationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.deleteByPublicLocationIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationByIdRaw(requestParameters: GetLocationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullLocationUi>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling getLocationById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/location/{publicId}`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getLocationById(requestParameters: GetLocationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullLocationUi> {
        const response = await this.getLocationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LocationOptionDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/location/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getLocationOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LocationOptionDTO>> {
        const response = await this.getLocationOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationsTableRaw(requestParameters: GetLocationsTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LocationTableResponse>> {
        if (requestParameters['locationTableRequest'] == null) {
            throw new runtime.RequiredError(
                'locationTableRequest',
                'Required parameter "locationTableRequest" was null or undefined when calling getLocationsTable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/location/table`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['locationTableRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getLocationsTable(requestParameters: GetLocationsTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LocationTableResponse> {
        const response = await this.getLocationsTableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateLocationRaw(requestParameters: UpdateLocationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LocationInListDTO>> {
        if (requestParameters['updateLocationRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationRequest',
                'Required parameter "updateLocationRequest" was null or undefined when calling updateLocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/location`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateLocationRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateLocation(requestParameters: UpdateLocationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LocationInListDTO> {
        const response = await this.updateLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
